<template>
	<div id="landing-page-footer" class="light-text">
		<div class="center-footer">
			<span>
				<p class="left-text">© Copyright 2020 vdpResearch</p>
			</span>
			<span>
		
				<router-link to="contact">
					<label><p class="right-text clickable small-hidden">Kontakt</p></label>
				</router-link>
				
				<router-link to="privacy">
					<label><p class="right-text clickable small-shown">Datenschutz</p></label>
				</router-link>
				
				<router-link to="imprint">
					<label><p class="right-text clickable">Impressum</p></label>
				</router-link>
				
				<router-link to="privacy">
					<label><p class="right-text clickable small-hidden" >Datenschutz</p></label>
				</router-link>
				
				<router-link to="contact">
					<label><p class="right-text clickable small-shown">Kontakt</p></label>
				</router-link>
			</span>
		</div>
	</div>
</template>

<script>
	export default {
		Name: 'LandingPageFooter',
		methods: {
			linkTo(event) {
				this.$emit(event);
			}
		}
	}
</script>

<style scoped>
	#landing-page-footer {
		background-color: #384554;
		display: inline-block;
		width: 100%;
	}

	.center-footer {
		width: 60%;
		max-width: 1500px;
		margin: auto;
	}

	p {
		color: white;
		margin: 1em;
	}

	p.left-text {
		float: left;
	}

	p.right-text {
		float: right;
	}
	
	
	
	@media(max-width: 1199px) {
		.center-footer {
			width: 80%;
		}
	}
	
	@media(min-width: 768px) {
		.small-shown {
		display: none !important;
		}
		
		.small-hidden {
			display: inline-block !important;
		}
	}

	@media(max-width: 767px) {
		#landing-page-footer {
			grid-template-columns: 1fr;
		}
		
		.small-shown {
			display: inline-block !important;
		}
		
		.small-hidden {
			display: none !important;
		}

		p.left-text {
		float: none;
	}

		p.right-text {
			float: none;
			display: inline-block;
		}

		.center-footer {
			width: 90%;
		}
	}

</style>

